import React from "react";
import PayslipCard from "../MyPayslip/PayslipCard";

const PayslipList = ({ employees = [] }) => {
    if (!Array.isArray(employees)) {
        return null; // or return <p>No data</p>
    }

    return (
        <>
            {employees.map((emp) => (
                <div key={emp.emp_no} className="single-payslip">
                    <PayslipCard emp={emp} />
                </div>
            ))}
        </>
    );
};

export default PayslipList;